import type React from 'react';
import usePermissions from '../hooks/usePermissions';
import type { Permission } from '../permissions';

interface PermissionsGateProps {
  permissions: Permission | Permission[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
  requireAll?: boolean;
}

const PermissionsGate = ({ permissions, children, fallback, requireAll = false }: PermissionsGateProps) => {
  const { isAccessAllowed, hasAllPermissions } = usePermissions();

  const hasAccess = requireAll ? hasAllPermissions(Array.isArray(permissions) ? permissions : [permissions]) : isAccessAllowed(permissions);

  if (hasAccess) return <>{children}</>;
  if (fallback) return <>{fallback}</>;
  return null;
};

export default PermissionsGate;
